var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMoneyEverywhereplaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3046,
    height: 1479,
    viewBox: "0 0 3046 1479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1740",
    "data-name": "Rectangle 1740",
    width: 3046,
    height: 1479
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMoneyEverywhereplaceholder);
export default __webpack_public_path__ + "static/media/send_money_everywhere.placeholder.08a1d4d749bea394828ffce1211d6d07.svg";
export { ForwardRef as ReactComponent };